import template from './ordinacijaList.html';
import ListController from '../common/list.controller.js';

class OrdinacijaListController extends ListController {
    constructor(ModelFactory, $state) {
        super(ModelFactory);
        this.getState();
        this.icon = $state.current.data.icon || false;
        this.pageTitle = $state.current.data.pageTitle || false;
        this.pageDesc = $state.current.data.pageDesc || false;

        this.getState();
    }

    getState() {
        this.getItems();
    }

    getQueryset(params) {
        return this.Model.findAll(params, {bypassCache: true});
    }

}

OrdinacijaListController.$inject = ['Ordinacija', '$state'];

const OrdinacijaListComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OrdinacijaListController,
    controllerAs: 'vm',
};

export {OrdinacijaListComponent};
export {OrdinacijaListController};



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacijaList.component.js